import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

interface VerifyMobileOtpRequestData {
  mobileOtp: string
}

export interface VerifyMobileOtpRequest extends Partial<AxiosRequestConfig> {
  params: VerifyMobileOtpRequestData
}

interface VerifyMobileOtpResponseData extends ResponseData {
  message: string
  success?: boolean
  userId?: number
}

export interface VerifyMobileOtpResponse extends AxiosResponse {
  data: VerifyMobileOtpResponseData
}

export function verifyMobileOtpAPI(
  { params }: VerifyMobileOtpRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params: { avoidClientSideAuth: true },
    method: "get",
    url: `/auth/mobile/verify-otp?mobileOtp=${params.mobileOtp}`,
  }) as Promise<VerifyMobileOtpResponse>
}
